import { useState, useEffect } from 'react';
import adminService from '../../../services/adminService';
import api from '../../../services/api';
import './AdminSlider.css';

const AdminUserDetail = ({ user, onBack }) => {
  const [projects, setProjects] = useState([]);
  const [editors, setEditors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingProject, setEditingProject] = useState(null);

  useEffect(() => {
    fetchDetails();
  }, [user._id]);

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const projectsRes = await api.get(`/api/timelines?userId=${user._id}`);
      setProjects(Array.isArray(projectsRes.data) ? projectsRes.data : []);
    } catch { setProjects([]); }
    try {
      const editorsRes = await api.get(`/api/admin/users/${user._id}/editors`);
      setEditors(Array.isArray(editorsRes.data) ? editorsRes.data : []);
    } catch { setEditors([]); }
    setLoading(false);
  };

  const handleDeleteProject = async (projectId, title) => {
    if (!window.confirm(`"${title}" projesini silmek istediğinizden emin misiniz?`)) return;
    setError(''); setSuccess('');
    try {
      await api.delete(`/api/timelines/${projectId}`);
      setProjects(projects.filter(p => p._id !== projectId));
      setSuccess('Proje silindi.');
    } catch { setError('Proje silinemedi.'); }
  };

  const handleDeleteEditor = async (editorId, username) => {
    if (!window.confirm(`"${username}" alt hesabını silmek istediğinizden emin misiniz?`)) return;
    setError(''); setSuccess('');
    try {
      await adminService.deleteUser(editorId);
      setEditors(editors.filter(e => e._id !== editorId));
      setSuccess('Alt hesap silindi.');
    } catch { setError('Alt hesap silinemedi.'); }
  };

  const handleSaveProject = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await api.put(`/api/timelines/${editingProject._id}`, {
        title: editingProject.title,
        intro: editingProject.intro,
        isPublic: editingProject.isPublic,
      });
      setProjects(projects.map(p => p._id === editingProject._id ? { ...p, title: editingProject.title, intro: editingProject.intro, isPublic: editingProject.isPublic } : p));
      setEditingProject(null);
      setSuccess('Proje güncellendi.');
    } catch { setError('Proje güncellenemedi.'); }
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  return (
    <div className="admin-slider">
      {/* Geri Butonu */}
      <button onClick={onBack} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: '0.875rem', marginBottom: '1rem', padding: '0.5rem 0' }}>
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: '1rem', height: '1rem' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" /></svg>
        Kullanıcılara Dön
      </button>

      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      {/* Kullanıcı Bilgileri */}
      <div className="admin-slider-card" style={{ marginBottom: '1.5rem' }}>
        <div className="admin-slider-header">
          <h3>{user.username}</h3>
          <span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{user.email}</span>
        </div>
        <div style={{ padding: '1rem 1.5rem', display: 'flex', gap: '2rem', flexWrap: 'wrap', fontSize: '0.85rem', color: '#d1d5db' }}>
          <span>Çizelge: {user.timelineCount || 0} / {user.maxTimelines}</span>
          <span>Rol: {user.role || 'user'}</span>
          <span>Grup: {user.canCreateGroup ? `Aktif (${user.maxEditors} limit)` : 'Yok'}</span>
        </div>
      </div>

      {/* Projeler */}
      <div className="admin-slider-card" style={{ marginBottom: '1.5rem' }}>
        <div className="admin-slider-header">
          <h3>Projeleri ({projects.length})</h3>
        </div>

        {/* Proje Düzenleme Formu */}
        {editingProject && (
          <form className="admin-slider-form" onSubmit={handleSaveProject}>
            <h4>Proje Düzenle: {editingProject.title}</h4>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={editingProject.title} onChange={(e) => setEditingProject({ ...editingProject, title: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama</label>
              <textarea value={editingProject.intro || ''} onChange={(e) => setEditingProject({ ...editingProject, intro: e.target.value })} rows="3" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div className="admin-slider-form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                <input type="checkbox" checked={editingProject.isPublic || false} onChange={(e) => setEditingProject({ ...editingProject, isPublic: e.target.checked })} style={{ accentColor: '#2563eb' }} />
                <span>Herkese Açık</span>
              </label>
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Kaydet</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setEditingProject(null)}>İptal</button>
            </div>
          </form>
        )}
        {projects.length > 0 ? (
          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {projects.map(project => (
              <div key={project._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 1rem', backgroundColor: '#374151', borderRadius: '0.5rem' }}>
                <div>
                  <strong style={{ color: '#f3f4f6', fontSize: '0.9rem' }}>{project.title}</strong>
                  {project.intro && <p style={{ color: '#9ca3af', fontSize: '0.75rem', margin: '0.2rem 0 0 0' }}>{project.intro.substring(0, 80)}</p>}
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
                  <button className="admin-slider-btn-edit" onClick={() => window.open(`/cizelge/${project.slug || project._id}`, '_blank')}>Görüntüle</button>
                  <button className="admin-slider-btn-edit" style={{ backgroundColor: '#f59e0b' }} onClick={() => window.open(`/cizelge/${project.slug || project._id}`, '_blank')}>Düzenle</button>
                  <button className="admin-slider-btn-delete" onClick={() => handleDeleteProject(project._id, project.title)}>Sil</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="admin-slider-empty">Henüz projesi yok.</div>
        )}
      </div>

      {/* Alt Hesaplar */}
      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Alt Hesapları ({editors.length})</h3>
        </div>
        {editors.length > 0 ? (
          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {editors.map(editor => (
              <div key={editor._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 1rem', backgroundColor: '#374151', borderRadius: '0.5rem' }}>
                <div>
                  <strong style={{ color: '#f3f4f6', fontSize: '0.9rem' }}>{editor.username}</strong>
                  <span style={{ color: '#9ca3af', fontSize: '0.75rem', marginLeft: '0.75rem' }}>{editor.email}</span>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
                  <button className="admin-slider-btn-delete" onClick={() => handleDeleteEditor(editor._id, editor.username)}>Sil</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="admin-slider-empty">Alt hesabı yok.</div>
        )}
      </div>
    </div>
  );
};

export default AdminUserDetail;
